/* unplugin-vue-components disabled */import script from "./CommonCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./CommonCenter.vue?vue&type=script&setup=true&lang=js"

import "./CommonCenter.vue?vue&type=style&index=0&id=5bbc922e&lang=scss"

const __exports__ = script;

export default __exports__